// DashboardLayout.tsx
import { MainErrorFallback } from '@/components/errors/main';
import { Spinner } from '@/components/ui/spinner';
import { Toaster } from '@/components/ui/toast/toaster';
import { ReactNode, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Footer } from '../../components/footer/footer';
import { DashboardSidebar } from './dashboard-sidebar';

interface Props {
  children: ReactNode;
}

export const DashboardLayout = ({ children }: Props) => {
  return (
    <Suspense
      fallback={
        <div className="flex size-full items-center justify-center">
          <Spinner size="xl" />
        </div>
      }
    >
      <ErrorBoundary key={location.pathname} fallback={<MainErrorFallback />}>
        <div className="flex min-h-screen flex-col">
          <DashboardSidebar>
            <div className="flex flex-1 flex-col">
              {children}
              <Footer />
            </div>
          </DashboardSidebar>
        </div>
        <Toaster />
      </ErrorBoundary>
    </Suspense>
  );
};
